// extracted by mini-css-extract-plugin
export default {"home":"People_home__UjwM+","arrow":"People_arrow__FIshI","title":"People_title__Uo73e","songs":"People_songs__bE+YH","link":"People_link__7PNa5"};